var map = {
	"./black/gengxin.png": "cPZ0",
	"./blue/gengxin.png": "Gfx/",
	"./white/gengxin.png": "0Sfa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yBkS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/gengxin\.png$
// module id = yBkS
// module chunks = 24